module.exports = __webpack_public_path__ + "img/4.6e18694.jpg";